import React from 'react';
import { Button, Popup, Stack, Typography } from 'witmeg-ui-system';
import "./TimeoutPopup.scss"
const TimeoutPopup = ({ onOkConfirm, onContinueClick }) => {

    return (
        <Popup
            className="timeout-popup"
            modalVisible={true}
            modalTitle=""
            mask={true}
            centered
            closable={false}>
            <div className='modal-header-text'>Your session has timed out.</div>
            <div className='modal-sub-text'>Your session needs to be refreshed. Would you like to continue your current order or clear your session and start a new one?.</div>
            < div className='btn-container-wparr ' >
                < div className='btn-container-clear' onClick={onOkConfirm}>Clear</div>
                < div className='btn-container' onClick={onContinueClick}>Continue</div>
            </div>
        </Popup>
    );
}

export default TimeoutPopup;